import { v4 as uuidv4 } from 'uuid';

export function InfoCard(props) {
	return {
		componentId: uuidv4(),
		componentName: 'InfoCard',
		props: Object.assign(
			{
				isFullModeStyle: true,
				textPosition: 'left',
				imageUrl:
					'https://res.cloudinary.com/kentcdodds-com/image/upload/v1625032892/kentcdodds.com/content/blog/how-to-use-react-context-effectively/banner.jpg',
				headline: 'Promoções de Outono',
				subhead: '',
				callToActionText: 'Conferir',
				callToActionUrl: '/sale/d',
				callToActionMode: 'button',
				blockClass: '',
				textAlignment: 'left',
			},
			props,
		),
	};
}
